module.exports = __webpack_public_path__ + "img/icon-make-admin.3583c021.svg";